<script setup lang="ts">
import { useWindowScroll, useElementSize } from '@vueuse/core';
import { computed, useTemplateRef, ref, watch } from 'vue';

const banner = useTemplateRef('banner');
const { height } = useElementSize(banner);
const { y } = useWindowScroll();
const hasBeenVisible = ref(false);

const showWithAnimation = computed(() => {
  return y.value > height.value;
});

const isInitiallyHidden = computed(() => !showWithAnimation.value && !hasBeenVisible.value);

watch(showWithAnimation, (visible) => {
  if (visible) hasBeenVisible.value = true;
});
</script>

<template>
  <div
    ref="banner"
    id="consent-banner"
    :class="{
      'invisible opacity-0': isInitiallyHidden,
      'animate-[fadeInUp_0.4s_ease-out_both]': showWithAnimation,
      'animate-[fadeOutDown_0.4s_ease-out_both]': !showWithAnimation && hasBeenVisible,
    }"
  />
</template>
